import { TYPES as APPSTATE_TYPES } from '@monofe/appstate';
import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import type { IA2HS } from './interface';
import { bindA2HS, injectA2HS, unbindA2HS } from './interface';
import { TYPES } from './private';
import store from './state';
import type { IModuleState } from './state/interface';
import { useNeedsPopUp, useStateHasShown } from './util/hook';
import MainView from './views/MainView';

function _buildLocalDependencies(container: IContainer) {
    return Promise.resolve({
        store: store(),
    });
}

function _buildModule(deps: { store: IModuleState }): IA2HS {
    let hasSetSiteName = false;
    const Render = (): JSX.Element | null => {
        const store = deps.store.useState();
        const [hasShown, setHasShown] = useStateHasShown();
        const canShow = useNeedsPopUp();

        if (!hasSetSiteName || hasShown || !canShow) {
            return null;
        }

        return (
            <button
                aria-label={store.subheading.text}
                onClick={() => {
                    setHasShown(true);
                }}
                style={{ width: '100%', height: '100%' }}
            >
                <MainView {...store} />
            </button>
        );
    };

    const alert: IA2HS = {
        renderer: Render,
        setSiteName: (siteName: string) => {
            deps.store.action.updateHeadingText(`Install ${siteName || 'site'}`);
            hasSetSiteName = true;
        },
    };

    return alert;
}

async function binder(container: IContainer): Promise<Readonly<IA2HS>> {
    const deps = await _buildLocalDependencies(container);

    const module = _buildModule(deps);

    return Object.freeze(module);
}

export default buildBindable<IA2HS>({
    id: TYPES.IA2HS,
    dependencies: [APPSTATE_TYPES.IStoresReducer],
    bind: bindA2HS,
    remove: unbindA2HS,
    inject: injectA2HS,
    build: container => binder(container),
});
